import Vue from 'vue'

import '@finx/web-repository/src/plugins/Analytics'
import '@finx/web-repository/src/plugins/Axios'

import '@/plugins/Vuetify'
import '@/plugins/CurrencyField'
import '@/plugins/VueUpload'
import '@/plugins/VCalendar'
import '@/plugins/VueDatetime'
import '@/plugins/PerfectScrollBar'
import '@/plugins/VueSanitize'
import '@/plugins/VueTheMask'
import '@/plugins/VueInputFacade'
import User from '@/plugins/User'
import GetDemo from '@/plugins/GetDemo'

import Iugu from '@/plugins/Iugu'

Vue.use(User)
Vue.use(GetDemo)
